import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createPlantUnit,
  listGenerationSites,
  listPlantUnits,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/** 電源ユニットの登録 mutation。成功したら一覧 (と、同時に作った発電所の一覧) を最新化する。 */
export function useCreatePlantUnit(): InvalidatingMutationResultFor<
  typeof createPlantUnit
> {
  return useInvalidatingMutation(createPlantUnit, [
    createConnectQueryKey({
      schema: listPlantUnits,
      cardinality: 'finite',
    }),
    // 新しい発電所を同時に作る登録・発電所の付け替えで、発電所の一覧も変わる
    createConnectQueryKey({
      schema: listGenerationSites,
      cardinality: 'finite',
    }),
  ])
}
